import { useEffect, useState } from "react";
import EarnCashBackComponent from "../../components/earnCashBack";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { getEarnCashbackApi } from "../../services/skincare.service";

const EarnCashBack = () => {
  const [data, setData] = useState<any>();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      getEarnCashbackApi({
        finalCallback: () => {},
        successCallback: (data?: any) => {
          setData(data);
        },
      })
    );
  }, []);

  return <EarnCashBackComponent data={data} />;
};

export default EarnCashBack;
